// extracted by mini-css-extract-plugin
module.exports = {"text_container":"ContributionReviews_text_container__2ETCB"};